// Record List Actions
export const FETCH_RECORDS_REQUEST = 'FETCH_RECORDS_REQUEST';
export const FETCH_RECORDS_SUCCESS = 'FETCH_RECORDS_SUCCESS';
export const FETCH_RECORDS_FAILURE = 'FETCH_RECORDS_FAILURE';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const FETCH_RECORDS_COUNT_SUCCESS = 'FETCH_RECORDS_COUNT_SUCCESS';
export const CHANGE_TAB = 'CHANGE_TAB';
export const SET_FILTER = 'SET_FILTER';
export const SET_FILTER_ERROR = 'SET_FILTER_ERROR';
export const RESET_FILTERS = 'RESET_FILTERS';
export const INIT_SEARCH_PAGE = 'INIT_SEARCH_PAGE';
export const SEARCH_ALREADY_INIT = 'SEARCH_ALREADY_INIT';
export const RESET_COUNT_CURRENTPAGE_PAGECOUNT = 'RESET_COUNT_CURRENTPAGE_PAGECOUNT';
export const SET_FILTER_SUPERVISOR = 'SET_FILTER_SUPERVISOR';
export const RESET_STATE = 'RESET_STATE';
export const SET_SORT = 'SET_SORT';
export const FETCH_USER_FEEDS = 'FETCH_USER_FEEDS';
export const CHANGE_POS = 'CHANGE_POS';
